function updateCarouselToImage(carouselContainer, imageId) {
  if (!carouselContainer) return;

  const template = carouselContainer.querySelector('template');
  if (!template) return;

  const currentImage = carouselContainer.querySelector('img');
  if (!currentImage || template.content.children.length === 0) return;

  const newImage = Array.from(template.content.children).find(
    (img) => img.dataset.id === imageId
  );
  if (!newImage) return;

  currentImage.replaceWith(newImage);
  template.content.appendChild(currentImage);
}

function handleRadioChange(event) {
  const radio = event.target;
  const imageId = radio.dataset.imageId;

  const carouselContainer = document.querySelector('.carousel-controls')?.parentElement;
  if (!carouselContainer) return;

  updateCarouselToImage(carouselContainer, imageId);
}

document.querySelectorAll('.cav-product-form__variant-item input[type="radio"]').forEach((radio) => {
  radio.addEventListener('change', handleRadioChange);
});

function updateCarousel(button, direction) {
  const carouselContainer = button.closest('.carousel-controls')?.parentElement;
  if (!carouselContainer) return;

  const template = carouselContainer.querySelector('template');
  if (!template) return;

  const currentImage = carouselContainer.querySelector('img');
  if (!currentImage || template.content.children.length === 0) return;

  const isNext = direction === 'next';
  const newImage = isNext
    ? template.content.children[0]
    : template.content.children[template.content.children.length - 1];

  currentImage.replaceWith(newImage);

  if (isNext) {
    template.content.appendChild(currentImage);
  } else {
    template.content.insertBefore(currentImage, template.content.firstChild);
  }
}

document.querySelectorAll('.carousel-prev, .carousel-next').forEach((button) => {
  button.addEventListener('click', () => {
    const direction = button.classList.contains('carousel-next') ? 'next' : 'prev';
    updateCarousel(button, direction);
  });
});